// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__KGFgr","inputWrap":"CustomTip_inputWrap__2lqSR"};